import { Component } from 'react';
import User from 'services/user2';

class Index extends Component {
  async init() {
    let userInfo = User.getUserInfo();
    let isLogin = userInfo.id === undefined ? false : true;
    let companyList = User.getCompanyList();

    if (!isLogin) {
      this.props.history.push('/mp/login');
    } else if (companyList.length === 0) {
      this.props.history.push('/mp/create-company');
    } else {
      let params = new URLSearchParams(window.location.search);
      let companyCode = params.get('companyCode');
      let path = params.get('path');
      let isIpSafe = true;
      let defaultCompanyCode = User.getCompanyCode();

      //处理切换公司后跳转页面
      if (companyCode && path) {
        if (defaultCompanyCode === companyCode) {
          //当前公司
          isIpSafe = await User.checkIpLimit(companyCode);
          if (isIpSafe) {
            this.props.history.push(path);
          }
          return;
        }
        let defaultCompany = companyList.find(item => {
          return item.companyCode === companyCode;
        });
        if (defaultCompany) {
          //必须先切换默认公司，否则检查IP限制接口的header中companyCode会和当前params中的不一致而导致抛出错误。
          User.setCompanyCode(defaultCompany.companyCode);
          isIpSafe = await User.checkIpLimit(defaultCompany.companyCode);
          if (isIpSafe) {
            //await this.user.getMenuAuth(); //重新获取权限
            this.props.history.push(path);
            //触发head-top更新
            // setTimeout(() => {
            //   Public.ts = Date.now();
            // }, 100);
          }
          return;
        }
      } else {
        isIpSafe = await User.checkIpLimit(defaultCompanyCode);
        if (isIpSafe) {
          this.props.history.push('/mp/workbench');
        }
      }
    }
  }

  componentDidMount() {
    this.init();
  }

  render() {
    return '';
  }
}

export default Index;
